/**
 * Default HTML template
 */
const DEFAULT_HTML = `
<table
  class="main-body"
  data-gjs-removable="false"
  data-gjs-draggable="false"
  data-gjs-droppable="false"
>
  <tr class="row">
    <td class="main-body-cell">
      <table class="container">
        <tr>
          <td class="container-cell">


            <table class="card">
              <tr>
                <td class="card-cell">
                  <table class="table100 c1357">
                    <tr>
                      <td class="card-content">
                        <h1 class="card-title">
                          Build your templates faster than ever
                          <br />
                        </h1>

                        <p class="card-text">
                          Import, build, test and export responsive templates
                          faster than ever using the Template Studio.
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table
              class="custom-content-table"
              data-gjs-removable="false"
              data-gjs-draggable="false"
              data-gjs-droppable="false"
            >
              <tr
                class="custom-content-cell"
                data-gjs-removable="false"
                data-gjs-draggable="false"
                data-gjs-droppable="false"
              >
                <td
                  class="card-content"
                  data-gjs-removable="false"
                  data-gjs-draggable="false"
                  data-gjs-droppable="false"
                >
                  <h1
                    class="card-title-center"
                    data-gjs-removable="false"
                    data-gjs-draggable="false"
                    data-gjs-droppable="false"
                  >
                    Welcome to the <br /><br />Template Studio<br />
                  </h1>

                  <p
                    class="card-text-welcome"
                    data-gjs-removable="false"
                    data-gjs-draggable="false"
                    data-gjs-droppable="false"
                  >
                    To get started, select your template from the Global Template library. Clone and save the selected template. You can add/edit/delete your draft and save to your account. You can also upload an HTML file of a template you already have and further edit it.
                  </p>

                  <p
                    class="card-text-welcome"
                    data-gjs-removable="false"
                    data-gjs-draggable="false"
                    data-gjs-droppable="false"
                  >
                    Create a brand‑new template. Start by selecting your baseline
                    template from the Template Library.
                  </p>
                        <button class="card-button"
                        data-action="open-library"
                        data-gjs-removable="false"
                        data-gjs-draggable="false"
                        data-gjs-droppable="false"
                        >Template Library</button>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
`;

export function getNewsletterTemplate(html?: string): string {
  return html || DEFAULT_HTML;
}

export function setTemplateFromSource(htmlFromS3: string): string {
  return htmlFromS3;
}

export default DEFAULT_HTML;
